import { PageShell } from '../../components/layout/page/PageShell';

type PortalPlaceholderPageProps = {
  title: string;
  description: string;
};

export function PortalPlaceholderPage({ title, description }: PortalPlaceholderPageProps) {
  return (
    <PageShell>
      <h1 className="text-2xl font-bold text-secondary-900">{title}</h1>
      <p className="mt-2 text-sm text-secondary-600">{description}</p>
      <p className="mt-6 rounded-xl border border-dashed border-secondary-300 bg-white px-4 py-8 text-center text-sm text-secondary-500">
        Conteúdo em construção — mock visual na próxima tela.
      </p>
    </PageShell>
  );
}
